import { Button } from "antd";

const BtnComponent = ({ onClickHandler, label, hidden = false, disabled = false }) => {
    return (
        <Button type='default' onClick={onClickHandler} hidden={hidden} disabled={disabled}>{label}</Button>
    )
};

export default BtnComponent